var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "payment-processors", title: "Payment Processors" } },
    [
      _c("template", { slot: "copy" }, [
        _c(
          "p",
          [
            _vm._v(
              "\n      Font Awesome uses payment processing services to collect and use\n      "
            ),
            _c("site-link", { attrs: { to: { hash: "#payment-data" } } }, [
              _vm._v("payment card data"),
            ]),
            _vm._v("\n      :\n    "),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass: "roomy",
            attrs: {
              summary:
                "a list of content delivery network service providers Font Awesome uses",
            },
          },
          [
            _c("thead", [
              _c("tr", [
                _c("th", [_vm._v("Service")]),
                _vm._v(" "),
                _c("th", [_vm._v("Privacy Notice")]),
              ]),
            ]),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://www.braintreepayments.com/",
                      },
                    },
                    [_vm._v("\n              Braintree\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://www.braintreepayments.com/legal/braintree-privacy-policy",
                      },
                    },
                    [
                      _vm._v(
                        "\n              https://www.braintreepayments.com/legal/braintree-privacy-policy\n            "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _c(
                    "a",
                    { attrs: { target: "_blank", href: "https://paypal.com" } },
                    [_vm._v("\n              PayPal\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://paypal.com/privacy",
                      },
                    },
                    [
                      _vm._v(
                        "\n              https://paypal.com/privacy\n            "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _c(
                    "a",
                    { attrs: { target: "_blank", href: "https://stripe.com" } },
                    [_vm._v("\n              Stripe\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://stripe.com/privacy",
                      },
                    },
                    [
                      _vm._v(
                        "\n              https://stripe.com/privacy\n            "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }